module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "size": _vm.size
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55d2ab06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/general/BackButton.vue
// module id = 751
// module chunks = 2